import { action, onCtxAbort, reaction } from '@reatom/framework'

import { delugeIdAtom } from '@root/entities/auth/atoms'
import { selectedNetworkAtom } from '@root/entities/network/atoms'
import { isInitializationReadyAtom } from '@root/features/initialization/atoms/common'
import { deviceWalletIdsAtom } from '@root/features/secure-storage/atoms'
import { dependenciesAtom } from '@root/features/shared/dependencies'

// eslint-disable-next-line @reatom/unit-naming-rule
export const setMakerFilterEvent = action<{ maker: string | undefined }>(
  'setMakerFilterEvent',
)

export * from './reatom-trades-table'

export const initializeUserTradesAction = reaction((ctx) => {
  const isReady = ctx.spy(isInitializationReadyAtom)
  const delugeId = ctx.spy(delugeIdAtom)
  if (!delugeId || !isReady) {
    return
  }
  const network = ctx.spy(selectedNetworkAtom)
  const { chartWebsocket } = ctx.get(dependenciesAtom)

  const walletIds = ctx.get(deviceWalletIdsAtom)
  for (const walletId of walletIds) {
    chartWebsocket.subscribeNewTxByMakerAction(ctx, {
      makerAddress: walletId,
      network: network,
    })
  }

  onCtxAbort(ctx, () => {
    for (const walletId of walletIds) {
      chartWebsocket.unsubscribeNewTxByMakerAction(ctx, {
        makerAddress: walletId,
        network: network,
      })
    }
  })
}, 'initializeUserTradesAction')
